




















import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import { CalendarData } from "../types";

@Component
export default class ExtendModal extends Vue {
    @Prop() currentMeeting!: CalendarData | null;
    @Prop() now!: moment.Moment;
    @Prop() nextMeeting!: CalendarData;
    @Prop() translations!: any;
    @Prop() hub!: any;
    @Prop() roomEmail!: string;
    @Prop() buttonStyle!: string;
    @Prop() buttonColor!: string;
    @Prop() subscriptionStarted!: boolean;

    isOpen = false;
    m = moment;

    get allowedExtensionTimes() {
        if (!this.currentMeeting) return;

        let currentMeeting = moment(this.currentMeeting.EndDateTime);
        let amountOfButtons = 4;

        if (this.nextMeeting) {
            const minuteDifference = moment.duration(moment(this.nextMeeting.StartDateTime).startOf("minute").diff(currentMeeting.startOf("minute"))).asMinutes();
            amountOfButtons = minuteDifference / 15;
            if (amountOfButtons > 4) amountOfButtons = 4;
        }

        const allowedExtensionTimes = [];
        for (let index = 0; index < amountOfButtons; index++) {
            currentMeeting = moment(currentMeeting).add("15", "minutes");
            allowedExtensionTimes.push(moment(currentMeeting));
        }

        return allowedExtensionTimes;
    }

    open() {
        this.isOpen = true;
    }

    close() {
        this.isOpen = false;
    }

    extendMeeting(time: moment.Moment) {
        if (this.currentMeeting && this.currentMeeting.Id) {
            // Quick extend the meeting
            console.log("Quick extending appointment");
            this.close();

            if (!this.subscriptionStarted) return;
            this.$emit("setLoading", "extend");

            const endTime = moment(time).set("seconds", 0).set("milliseconds", 0);
            const tempEndTime = this.currentMeeting.EndDateTime;
            this.currentMeeting.EndDateTime = endTime.toISOString();

            this.hub.invoke("extendAppointment", this.currentMeeting.Id, endTime.toISOString(), this.roomEmail).done((result: any) => {
                if (!result) {
                    // If we fail to extend the meeting, return to original state
                    console.log("Failed to extend appointment, returning appointment to original time");
                    if (this.currentMeeting) this.currentMeeting.EndDateTime = tempEndTime;
                } else this.$emit("setLoading", "");
            });
        }
    }
}
